import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import {DeliriumForm} from './deliriumForm';

const Delirium = (props) => {
    const {t} = useTranslation();

    const selectedForm = props.selectedHistoryForm;
    const [delirium, setDelirium] = useState({});

    const [formIsModified, setFormIsModified] = React.useState(false);

    const saveEntry = () => {
        if (!_.isEmpty(delirium)) {
            if (props.onSave) props.onSave(delirium);
            if (props.onChange) props.onChange(delirium);
        }
        if (props.onClose) props.onClose();
    };

    useEffect(() => {
        if (props.agyleDialogInsertButtons) {
            props.agyleDialogInsertButtons([
                <AgyleButton
                    variant="contained"
                    onClick={saveEntry}
                    disabled={props.disableSave || !formIsModified}
                >
                    {t('Submit')}
                </AgyleButton>,
            ]);
        }
        if (props.onSubmitFunction) {
            props.onSubmitFunction(saveEntry);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(props.disableSave || !formIsModified);
        }
    }, [props.disableSave, delirium, formIsModified]);

    return (
        <DeliriumForm
            patient={props.patient}
            save={(event) => {
                setDelirium(event);
                setFormIsModified(true);
            }}
            selectedForm={selectedForm}
            parentForm={props.parentForm}
        />
    );
};

export default Delirium;